import { render, staticRenderFns } from "./ReviewsList.vue?vue&type=template&id=e2ba064e"
import script from "./ReviewsList.vue?vue&type=script&lang=js"
export * from "./ReviewsList.vue?vue&type=script&lang=js"
import style0 from "./ReviewsList.vue?vue&type=style&index=0&id=e2ba064e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports